<template>
  <div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
console.log(process.env.NODE_ENV);
export default {
  name: "app",
  created() {

  }
};
</script>

<style scoped>

/* 在 App.vue 的 style 中，或全局样式文件里 */
#app {
  max-width: 750px; /* 或其他你想要的手机宽度基准，如 375px、414px */
  margin: 0 auto;   /* 水平居中 */
  width: 100%;
  min-height: 100vh;
  position: relative;
  overflow-x: hidden; /* 防止水平滚动条 */
}


</style>